/**
 * Role użytkowników w systemie
 * Muszą być zsynchronizowane z backendem
 */
export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MODERATOR = 'moderator',
  USER = 'user',
  GUEST = 'guest',
}

/**
 * Mapowanie roli na label do wyświetlania
 */
export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super Administrator',
  [UserRole.ADMIN]: 'Administrator',
  [UserRole.MODERATOR]: 'Moderator',
  [UserRole.USER]: 'Użytkownik',
  [UserRole.GUEST]: 'Gość',
};
